import { render, staticRenderFns } from "./SupplierDataView.vue?vue&type=template&id=3e8f85e6&scoped=true"
import script from "./SupplierDataView.vue?vue&type=script&lang=js"
export * from "./SupplierDataView.vue?vue&type=script&lang=js"
import style0 from "./SupplierDataView.vue?vue&type=style&index=0&id=3e8f85e6&lang=scss&scoped=true"
import style1 from "./SupplierDataView.vue?vue&type=style&index=1&id=3e8f85e6&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8f85e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e8f85e6')) {
      api.createRecord('3e8f85e6', component.options)
    } else {
      api.reload('3e8f85e6', component.options)
    }
    module.hot.accept("./SupplierDataView.vue?vue&type=template&id=3e8f85e6&scoped=true", function () {
      api.rerender('3e8f85e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/settlementUnit/SupplierDataView.vue"
export default component.exports